import { render } from "./TutoQuizz.vue?vue&type=template&id=4256068c"
import script from "./TutoQuizz.vue?vue&type=script&lang=js"
export * from "./TutoQuizz.vue?vue&type=script&lang=js"

import "./TutoQuizz.vue?vue&type=style&index=0&id=4256068c&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__